// General
import { gsap, Power4 } from 'gsap'
import SimpleBar from 'simplebar';
import { dragscroll } from './lib/dragscroll'
import ResizeObserver from 'resize-observer-polyfill';
window.ResizeObserver = ResizeObserver;

import { ready } from './lib/utils/utils'
import iframeResizer from './lib/utils/iframeResizer.min.js';

// Stimulus.js and controllers
import { Application } from 'stimulus';
import ExpandableController from './lib/controllers/expandable-controller';
import NavMainSubMenuController from './lib/controllers/nav-main-sub-menu-controller';
import HeaderController from './lib/controllers/header-controller';
import SearchFieldController from './lib/controllers/search-field-controller';
import AccordionController from './lib/controllers/accordion-controller';
import AccordionItemController from './lib/controllers/accordion-item-controller';
import DisruptorController from './lib/controllers/disruptor-controller';
import KeyvisualController from './lib/controllers/keyvisual-controller';
import CarouselController from './lib/controllers/carousel.js';
import VideoController from './lib/controllers/video-controller.js';
import FeatureCarouselController from './lib/controllers/feature-carousel.js';
import SwiperController from './lib/controllers/swiper-controller.js';
import ContactBubbleController from './lib/controllers/contact-bubble-controller.js';
import PartnerListController from './lib/controllers/partner-list.js';

// Setup functions
import { SetupInViewDetection } from './lib/bootstrap/setup-in-view-detection';
import { SetupAnchorScrollTo, scrollTo } from './lib/bootstrap/setup-anchor-scroll-to';
import { SetupLightbox } from './lib/bootstrap/setup-lightbox';
import { SetupIsScrolledDetector } from './lib/bootstrap/setup-is-scrolled-detector';

gsap.defaults({
  ease: Power4.easeInOut,
  duration: 0.25
});

ready(function () {

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) document.body.classList.add("-is-ie-11");

  // Stimulus.js and controllers
  const application = Application.start();
  application.register('expandable', ExpandableController);
  application.register('nav-main-sub-menu', NavMainSubMenuController);
  application.register('header', HeaderController);
  application.register('search-field', SearchFieldController);
  application.register('accordion', AccordionController);
  application.register('accordion-item', AccordionItemController);
  application.register('disruptor', DisruptorController);
  application.register('keyvisual', KeyvisualController);
  application.register('carousel', CarouselController);
  application.register('video', VideoController);
  application.register('feature-carousel', FeatureCarouselController);
  application.register('swiper', SwiperController);
  application.register('contact-bubble', ContactBubbleController);
  application.register('partner-list', PartnerListController);

  const headerHeight = document.querySelector('header').offsetHeight;

  // Setup functions
  SetupInViewDetection();
  SetupAnchorScrollTo(120);
  SetupLightbox();
  SetupIsScrolledDetector(headerHeight);

  const scrollUp = document.querySelector('.arrow-scroll-up')
  scrollUp.addEventListener('click', (e) => {
    e.preventDefault();
    scrollTo(document.body, headerHeight)
  });

  const timeline = document.querySelector('.block__timeline');
  if (timeline) {
    new SimpleBar(timeline, {
      autoHide: false,
      scrollbarMinSize: 100,

    }
    );
    dragscroll.init('.simplebar-content-wrapper');

  }
  iframeResizer({}, '.iframe-resizer');

});